(function() {
  const SECTION_ID = document.currentScript?.dataset?.sectionId;

  async function fetchAndRender() {
    const container = document.getElementById('cart-drawer-progress-bar');
    if (!container) {
      console.warn('[ProgressBar] container #cart-drawer-progress-bar not found in DOM');
      return;
    }
    
    try {
      const url = Shopify.routes.root + '?sections=' + encodeURIComponent(SECTION_ID);
      const res = await fetch(url);
      const data = await res.json();
      const html = data[SECTION_ID];
      if (!html) {
        console.warn('[ProgressBar] section "' + SECTION_ID + '" not in response. Keys:', Object.keys(data));
        return;
      }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const sectionEl = doc.getElementById('shopify-section-' + SECTION_ID);
      if (!sectionEl) {
        console.warn('[ProgressBar] #shopify-section-' + SECTION_ID + ' not found in section HTML');
        return;
      }
      const sectionWrapper = document.createElement('div');
      sectionWrapper.setAttribute('id', 'shopify-section-' + SECTION_ID);
      sectionWrapper.classList.add('multi-step-progress-bar');
      sectionWrapper.innerHTML = sectionEl.innerHTML;

      // Mark as completed if there's no message, meaning the user has completed all steps.
      container.classList.toggle('completed', !doc.querySelector(".progress-message"));

      // Set the section's HTML inside the drawer's progress bar container.
      container.innerHTML = sectionWrapper.outerHTML;
    } catch (e) {
      console.error('[ProgressBar] fetch error:', e);
    }
  }

  const drawer = document.getElementById('cart-drawer');

  // Run AFTER the cart drawer has finished replacing its own DOM.
  drawer?.addEventListener('cart-drawer:refreshed', fetchAndRender);

  // Initial run in case the drawer is already open.
  fetchAndRender();
})();